// Lucide icon: clock-3 (https://lucide.dev/icons/clock-3)
import { Clock3 } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconTimer = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Clock3 />
    </IconComponentStyled>
  )
}
